import { Table } from '@mantine/core';
import classes from './styles.module.css';
import { UserActionPriority } from '@/services/api/settingsApiArea/types';
import { RowItem } from '@/containers/pages/commonSettings/tabs/EventsTrailPage/components/EventsTable/components/RowItem';
import { useTranslation } from 'react-i18next';

interface Props {
  events: UserActionPriority[];
}

export function EventsTable(props: Props) {
  const { t } = useTranslation();

  return (
    <Table>
      <Table.Thead>
        <Table.Tr>
          <Table.Th className={classes.headerCell}>{t('filials.settings.table.event')}</Table.Th>
          <Table.Th className={classes.headerCell}>{t('filials.settings.table.module')}</Table.Th>
          <Table.Th className={classes.headerCell}>
            {t('filials.settings.table.criticalityLevel')}
          </Table.Th>
        </Table.Tr>
      </Table.Thead>
      <Table.Tbody>
        {props.events.map((element, index) => (
          <RowItem key={index} element={element} />
        ))}
      </Table.Tbody>
    </Table>
  );
}
